import SupplyProductList from '@/pages/product/supplyProduct/index' // 云供应产品清单
import SupplyBrand from '@/pages/product/supplyBrand/index' // 品牌云供应管理
import SaledOrder from '@/pages/product/saledOrder/index' // 售后管理

export default [
  {
    path: '/product/supplyProdList',
    name: '产品云供应设置',
    component: SupplyProductList
  },
  {
    path: '/product/supplyCloudApply',
    name: '品牌云供应',
    component: SupplyBrand
  },
  {
    path: '/product/saledOrder',
    name: '售后管理',
    component: SaledOrder
  }
]
